// hooks/useCalendarNavigation.ts
import { Dayjs } from 'dayjs';

interface UseCalendarNavigationProps {
  currentMonth: number;
  currentYear: number;
  onMonthYearChange?: (month: number, year: number) => void;
  onDateChange: (date: Dayjs | null) => void;
}

export const useCalendarNavigation = ({
  currentMonth,
  currentYear,
  onMonthYearChange,
  onDateChange,
}: UseCalendarNavigationProps) => {
  const handlePreviousMonth = () => {
    let newMonth = currentMonth;
    let newYear = currentYear;

    if (currentMonth === 0) {
      newMonth = 11;
      newYear = currentYear - 1;
    } else {
      newMonth = currentMonth - 1;
    }

    onMonthYearChange?.(newMonth, newYear);
  };

  const handleNextMonth = () => {
    let newMonth = currentMonth;
    let newYear = currentYear;

    if (currentMonth === 11) {
      newMonth = 0;
      newYear = currentYear + 1;
    } else {
      newMonth = currentMonth + 1;
    }

    onMonthYearChange?.(newMonth, newYear);
  };

  const handleDateChange = (date: Dayjs | null) => {
    if (date) {
      if (date.month() !== currentMonth || date.year() !== currentYear) {
        onMonthYearChange?.(date.month(), date.year());
      }
    }
    onDateChange(date);
  };

  return {
    handlePreviousMonth,
    handleNextMonth,
    handleDateChange,
  };
};
